import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Headphones, Phone, ChevronRight, CircleHelp } from 'lucide-react';

const DistributorHelpPage = () => {
  const navigate = useNavigate();

  return (
    <div className="max-w-2xl mx-auto space-y-5 animate-fade-in" data-testid="distributor-help-page">
      {/* Header */}
      <div className="pt-1">
        <h1 className="text-3xl font-bold text-gray-900" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
          Ayuda
        </h1>
        <p className="text-sm text-gray-400 mt-1 font-medium">Centro de ayuda y atención</p>
      </div>

      {/* Hero */}
      <div className="bg-gradient-to-br from-amber-500 via-amber-400 to-orange-500 rounded-3xl p-7 relative overflow-hidden">
        <div className="absolute -right-8 -top-8 w-36 h-36 bg-white/10 rounded-full blur-sm" />
        <div className="absolute right-10 bottom-2 w-20 h-20 bg-white/5 rounded-full" />
        <div className="relative z-10">
          <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center mb-4 shadow-inner">
            <CircleHelp className="text-white" size={28} strokeWidth={1.8} />
          </div>
          <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            ¿Cómo podemos ayudarte?
          </h2>
          <p className="text-white/70 mt-1 text-sm">
            Selecciona una opción para obtener asistencia
          </p>
        </div>
      </div>

      {/* Sub-categories */}
      <div className="space-y-3">
        <button
          onClick={() => navigate('/distributor/support')}
          className="w-full bg-white rounded-2xl border border-gray-100/50 p-5 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-4 group"
          data-testid="help-soporte"
        >
          <div className="w-12 h-12 bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <Headphones size={22} className="text-amber-500" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Soporte</p>
            <p className="text-[11px] text-gray-400 mt-0.5">Crea y consulta tickets de soporte</p>
          </div>
          <ChevronRight size={18} className="text-gray-300 group-hover:text-amber-400 transition-colors" />
        </button>

        <button
          onClick={() => navigate('/distributor/contact')}
          className="w-full bg-white rounded-2xl border border-gray-100/50 p-5 text-left shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-300 flex items-center gap-4 group"
          data-testid="help-contacto"
        >
          <div className="w-12 h-12 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
            <Phone size={22} className="text-blue-500" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-gray-900 text-sm" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>Vías de Contacto</p>
            <p className="text-[11px] text-gray-400 mt-0.5">Teléfono, correo y redes sociales</p>
          </div>
          <ChevronRight size={18} className="text-gray-300 group-hover:text-blue-400 transition-colors" />
        </button>
      </div>
    </div>
  );
};

export default DistributorHelpPage;
